module.exports = __webpack_public_path__ + "static/media/med-ico-grey.8336fe34.svg";